import React from "react";
import { WebAppContext } from "./WAContainer";
import { LeftIcon, RightIcon } from "../Icon/Icon";
export const WASidenavToggleButton = () => {
  let state = WebAppContext.useContainer();
  return (
    <button
      className="wa-sidenav-collapse-toggle"
      onClick={() => {
        state.setExpanded(!state.expanded);
      }}
    >
      {state.expanded ? <LeftIcon /> : <RightIcon />}
      <span className="wa-sidenav-collapse-text">Collapse sidebar</span>
    </button>
  );
};
